import React from "react";

import moment from "moment";
import Highlighter from "react-highlight-words";

import LockedValue from "../../../../grace-period/components/LockedValue";
import { useAccessStatus } from "../../../../grace-period/hooks/useAccessStatus";
import { getCoaListItemTemplateTagStyle } from "../../helper";
import TemplateSectionLoading from "../Common/TemplateSectionLoading";

import { ReactComponent as CalendarIconList } from "../../../../../assets/images/environment/CalendarIconList.svg";
import { ReactComponent as DeleteIconList } from "../../../../../assets/images/environment/DeleteIconList.svg";
import { ReactComponent as DownloadIconList } from "../../../../../assets/images/environment/DownloadIconList.svg";

export default function COAListItem(props) {
  const {
    elem,
    toggleShowDeleteModal,
    onPreview,
    onDownload,
    previewBusy,
    searchedValue,
    readOnlyTemplateIds,
  } = props;
  const { areResultsLocked } = useAccessStatus();

  const handleDelete = (e) => {
    e.stopPropagation();
    toggleShowDeleteModal(elem);
  };

  const handleDownload = (e) => {
    e.stopPropagation();
    if (areResultsLocked) {
      return;
    }
    onDownload();
  };

  const handlePreview = () => {
    if (areResultsLocked || previewBusy) {
      return;
    }
    onPreview();
  };

  const listItem = (
    <div
      className={`coaListItemContainer coaListItemContainer--flat${areResultsLocked ? " coaListItemContainer--locked" : ""}`}
      onClick={handlePreview}
      role="button"
      tabIndex={areResultsLocked ? -1 : 0}
      aria-busy={previewBusy}
      aria-disabled={areResultsLocked}
      onKeyDown={(e) => {
        if (areResultsLocked) {
          return;
        }
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          handlePreview();
        }
      }}
    >
      <div className="coaListItemTitle">
        <Highlighter
          highlightClassName="coaListItemHeader__SearchHighlight"
          searchWords={[searchedValue]}
          autoEscape
          textToHighlight={elem.coa_name}
        />
      </div>
      <div className="coaListItemMeta">
        <div className="coaListItemDate">
          <CalendarIconList className="coaListItemIcon" aria-hidden />
          <span>
            {moment(elem.added_on).format("MM/DD/YYYY")}
          </span>
        </div>
        <div
          className="coaListItemTemplate"
          style={getCoaListItemTemplateTagStyle(elem, readOnlyTemplateIds)}
        >
          <span>
            {elem.template_name || "Deleted Template"}
          </span>
        </div>
        <DeleteIconList
          className="coaListItemIcon coaListItemDeleteIcon"
          onClick={handleDelete}
          aria-label="Delete report"
        />
        {areResultsLocked ? (
          <span
            className="coaListItemLockWrap"
            onClick={(e) => e.stopPropagation()}
            aria-label="Report locked until payment is completed"
          >
            <LockedValue locked blur={false} />
          </span>
        ) : (
          <DownloadIconList
            className="coaListItemIcon coaListItemDownloadIcon"
            onClick={handleDownload}
            aria-label="Download report"
          />
        )}
      </div>
      {previewBusy && (
        <TemplateSectionLoading variant="overlay" className="coaListItem__Loading" />
      )}
    </div>
  );

  return listItem;
}
